export const MAX_IMPORTED_AUDIO_NOTE_WAVEFORM_DECODE_DURATION_MS = 5 * 60 * 1000;

export const shouldDecodeSavedAudioNoteWaveformInBrowser = (data: {
    durationMs: number,
}): boolean => {
    const {
        durationMs,
    } = data;

    if (!Number.isFinite(durationMs) || durationMs <= 0) {
        return false;
    }

    return durationMs <= MAX_IMPORTED_AUDIO_NOTE_WAVEFORM_DECODE_DURATION_MS;
};

/**
 * Imported files can be much longer than recorded notes. Expanding a long
 * compressed upload into PCM just to draw preview bars can exhaust tab memory,
 * so browser-side waveform decoding is reserved for short imports only.
 */
export const shouldDecodeAudioNoteWaveformInBrowser = (data: {
    audioBlob: Blob | null,
    audioUploaded: boolean,
    durationMs: number,
}): boolean => {
    const {
        audioBlob,
        audioUploaded,
        durationMs,
    } = data;

    if (!audioBlob || audioBlob.size <= 0) {
        return false;
    }

    if (!audioUploaded) {
        return true;
    }

    return shouldDecodeSavedAudioNoteWaveformInBrowser({
        durationMs,
    });
};
